export enum LimitType {
  Daily,
  Weekly,
  Monthly
}
